import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

// Gate routes by subscription addon. Pass `any` (array of addon codes — match
// at least one). Unlike permissions, admins are NOT auto-granted addons.
export default function AddonGuard({ any }) {
  const { hasAddon, role } = useAuth();
  if (!role) return <Navigate to="/" replace />;
  if (Array.isArray(any) && !hasAddon(...any)) return <Navigate to="/" replace />;
  return <Outlet />;
}
